import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { EditableContent } from 'components/input/editable-content/editable-content.component';
import { FormattedContentDirective } from 'directives/formatted-content.directive';
import { InputType } from 'enums/InputType';
import { FormValidationService } from 'services/form-validation.service';
import { InputTypeDateTimeModel } from 'models/generated/Models.InputTypeData.InputTypeDateTime';
import { Inputs } from 'modules/inputs';
import { CustomDatePipe } from 'pipes/custom-date.pipe';
import { DateTimeInputComponent } from 'components/input/date-time-input/date-time-input.component';

@Component({
	selector: 'edit-row',
	providers: [FormValidationService],
	templateUrl: 'edit-row.component.html',
	imports: [EditableContent, Inputs, FormattedContentDirective, DateTimeInputComponent, FormsModule, CustomDatePipe]
})
export class EditRowComponent {

	inputTypeEnum = InputType;

	focusedInput = false;
	hover = false;
	inputCheckbox = false;
	dirty = false;

	@Output() valueChanged = new EventEmitter<any>();

	@Input() ignoreFormValidation = false;
	@Input() isHtmlContent = false;
	@Input() inputType: InputType = InputType.Text;
	@Input() selectList?: any;
	@Input() placeholder?: any;
	@Input() model?: string;
	@Input() label?: string;
	@Input() displayValue?: string;
	@Input() maxDate?: Date;

	getDateTime() {
		return typeof this.model == 'string' ? JSON.parse(this.model) as InputTypeDateTimeModel : null;
	}
}
